import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closePriceAlertModal } from '../../store/actions/alerts';
import PriceAlertModal from './PriceAlertModal';

/**
 * Renders PriceAlertModal at App-level driven by Redux state. Mirrors the
 * OrderWindowHOC pattern so the modal can't be unmounted by whatever component
 * (watchlist row, drawer, menu) triggered it.
 */
const PriceAlertModalHOC = () => {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.alerts?.modal) || { open: false };

  if (!modal.open) return null;

  return (
    <PriceAlertModal
      open={modal.open}
      onClose={() => dispatch(closePriceAlertModal())}
      instrument={modal.instrument}
      ltp={modal.instrument?.ltp}
      isModify={modal.isModify}
      existingAlert={modal.existingAlert}
    />
  );
};

export default PriceAlertModalHOC;
